import React from 'react'
import styled from 'styled-components'
import { generateMediaUrl } from 'utils'

import RemoveIcon from './ic-remove.svg'
import EditIcon from './ic-edit.svg'

/* eslint-disable camelcase */

const Equipment = ({
  name,
  classes,
  equipment_icon,
  selectedClass,
  onRemove,
  onEdit,
  showEnergyClass = true,
}) => (
  <Wrapper>
    <Left>
      {equipment_icon && (
        <Icon src={generateMediaUrl(equipment_icon.icon)} alt={name} />
      )}
      <Name>{name}</Name>
    </Left>
    <Right>
      {showEnergyClass && selectedClass && classes && classes.length > 1 && (
        <Classe>
          <Label>{selectedClass.classe_energetica.name}</Label>
        </Classe>
      )}
      <Actions>
        <Edit onClick={() => onEdit()} />
        <Remove onClick={() => onRemove()} />
      </Actions>
    </Right>
  </Wrapper>
)
/* eslint-enable camelcase */

export default Equipment

const Wrapper = styled.li`
  border: 1px solid #ccc;
  padding: 10px;
  margin-top: 5px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  flex-direction: row;
`

const Left = styled.span`
  flex: 0.5;
  align-items: center;
  display: flex;
`

const Right = styled.span`
  flex: 0.5;
  align-items: center;
  display: flex;
  justify-content: space-between;
`

const Icon = styled.img`
  margin-right: 10px;
  width: 35px;
  height: 35px;
`

const Name = styled.span`
  font-weight: bold;
  font-size: 14px;
`

const Classe = styled.span``

const Label = styled.span`
  font-weight: bold;
  margin-right: 5px;
`

const Remove = styled.button`
  width: 20px;
  height: 20px;
  background: none;
  outline: none;
  background-image: url(${RemoveIcon});
  background-size: contain;
  border: 0;
  background-repeat: no-repeat;
  cursor: pointer;
`

const Edit = styled.button`
  width: 20px;
  height: 20px;
  background: none;
  outline: none;
  background-image: url(${EditIcon});
  background-size: contain;
  border: 0;
  background-repeat: no-repeat;
  margin-right: 10px;
  cursor: pointer;
`

const Actions = styled.div`
  margin-left: auto;
`



// WEBPACK FOOTER //
// ./src/components/EquipmentListItem/index.js